import React from 'react'
import { Link } from 'react-router-dom';

export default function ListItems({ coin }) {
  return (
    <div className="home-crypto">
        <Link to={`/${coin.id}`}>
            <span className="home-crypto-image"><img src={coin.image} alt={coin.name ? `${coin.name} logo` : ''} /></span>

            <span className="home-crypto-name">{coin.name}</span>

            {coin.priceBTC && <span className="home-crypto-prices">
                <span className="home-crypto-btc">
                      <img src="/bitcoin.webp" alt="Bitcoin logo" />
                    {coin.priceBTC} BTC</span>
                <span className="home-crypto-usd">({coin.priceUSD} USD)</span>
            </span>
            }

        </Link>
  </div>
  )
}
